<template>
  <div>
    <div class="content grid justify-center 1.2xl:justify-between mr-3"
         :class="{'grid-cols-1 1.2xl:grid-cols-display-2 1.5xl:grid-cols-display-3 1.8xl:grid-cols-display-4 2.7xl:grid-cols-display-6 4k:grid-cols-display-8': filterOpen,'grid-cols-display-3 1.2xl:grid-cols-display-4 1.5xl:grid-cols-display-4 fhd:grid-cols-display-6 2xl:grid-cols-display-6 2.7xl:grid-cols-display-8 4k:grid-cols-display-12': !filterOpen}">
      <c-decor :selectedSelection="selectedSelection" v-for="(decor, index) in decors" :key="index"
               :decor="decor" :displayQuick="displayQuick"
               class="justify-self-center 1.5xl:justify-self-start"
      />
    </div>
    <button v-if="hasMore" class="classen__button justify-self-center hover__button col"
            @click="$emit('load-more')">
      {{ getTranslation('loadMoreItems') }}
    </button>
    <div v-if="decors.length === 0" class="">
      {{ getTranslation('noDecorsFound') }}
    </div>
  </div>
</template>
<script>
import getTranslation from "../../../mixins/getTranslation";
import DecorView from "./DecorView";

export default {
  name: "DecorsDisplay",

  mixins: [getTranslation],

  components: {
    'c-decor': DecorView,
  },

  props: {
    decors: {required: true, type: Array},
    filterOpen: {required: true, type: Boolean},
    hasMore: {required: true, type: Boolean},
    displayQuick: {required: true, type: Boolean},
    selectedSelection: {required: true, type: Object}
  },

  data() {
    return {}
  },

  created() {

  },

  destroyed() {

  },

  computed: {},

  watch: {},

  methods: {}
}
</script>

<style scoped>
</style>
